import axios from "axios";
import Cookies from "js-cookie";
import { API_BASE_URL } from "./config";

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    AppKey: "6E256BDE-B7FE-4A2E-8433-0C99677B91D8",
  },
});

/* REQUEST INTERCEPTOR */
instance.interceptors.request.use(
  (config) => {
    if (!config.headers["X-Public-Request"]) {
      const token = Cookies.get("Orbit_Token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* RESPONSE INTERCEPTOR */
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const isPublicRequest =
      error.config?.headers?.["X-Public-Request"];

    if (
      !isPublicRequest &&
      error.response &&
      (error.response.status === 401 ||
        error.response.status === 403)
    ) {
      console.warn("Unauthorized. Redirecting to login...");

      Cookies.remove("Orbit_Token");
      Cookies.remove("Orbit_UserName");
      Cookies.remove("Orbit_UserEmail");
      Cookies.remove("Orbit_PMCount");
      Cookies.remove("Orbit_DevCount");
      Cookies.remove("Orbit_TesterCount");

      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

export default instance;